import React, {memo, useEffect, useState} from 'react';
import {useTheme} from "../../../common/ProjectThemeProvider";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    copyTextToClipboard,
    focusFormIdElement,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue,
    jsonToStr,
    setTabTitle
} from "../../../common/fusion-ui/utils/ReactUtils";
import {printError, printLog} from "../../../common/CommonUtils";
import {AdminModules, AdminModuleTableCellType, AdminReqUrls} from "../../config/AdminConfig";
import {AdminInterface, ModuleTable, TableSkeleton} from "../../components";
import {CircleLoading, Flexbox, GridBox, Label, MsgBox, NullMsgLabel, PolyStateToggle, PrismSyntaxHighlighter, Section} from "../../../common/fusion-ui";
import {ThemedButton, ThemedIconButton, ThemedInput} from "../../../common/components";
import {CssVariant, IconClass, Messages} from "../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../common/fusion-ui/hook";
import {sendAdminRequest} from "../../utils/AdminUtils";
import {AnimationType, FramerAnimator} from "../../../common/fusion-ui/animation/FramerAnimator";

const QueryWindowPage = memo(() => {
    const TAG = "QueryWindowPage";

    const moduleName = AdminModules.QueryWindow;

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline} = useInternetStatus();

    const animator = new FramerAnimator();

    const PanelTypes = {
        queryResultsView: {id: 0, text: 'Results'},
        tableView: {id: 1, text: 'Tables'},
        // all: {id: 0, text: 'All', variant: 'primary', variantAlt: 'primary'},
    };
    const RESTRICTED_SQL_KEYWORDS = [
        "DROP",
        "DELETE",
        "TRUNCATE",
        "ALTER",
        "UPDATE",
        "INSERT",
        "CREATE",
        "GRANT",
        "REVOKE",
        "REPLACE",
        "EXECUTE",
        "CALL",
        "MERGE",
        "DISABLE",
        "ENABLE",
        "RENAME",
        "BACKUP",
        "RESTORE"
    ];

    const Fields = {
        queryValue: 'queryValue',

        queryResults: 'queryResults',
        tableColumnModel: 'tableColumnModel',
        queryExecSuccess: 'queryExecSuccess',
        queryExecMsg: 'queryExecMsg',

        dbTables: 'dbTables',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

        submitAsLoading: 'submitAsLoading',
        submitDisable: 'submitDisable',

        fetchTblListBtbAsLoading: 'fetchTblListBtbAsLoading',
        fetchTblListBtDisable: 'fetchTblListBtDisable',

        currVisPanelId: 'currVisPanelId',
    };
    const [fieldsData, setFieldsData] = useState({
        // [Fields.queryValue]: `SELECT * FROM users WHERE age > 21;`,
        [Fields.currVisPanelId]: PanelTypes.queryResultsView.id,
    });

    useEffect(() => {
        setTabTitle(moduleName);
    }, []);
    useEffect(() => {
    }, []);

    return (<>
        <AdminInterface moduleName={moduleName} tag={TAG} animate={false}>
            <div className={'mt-n2'}>
                <GridBox className={'px-1'} md={6}>
                    {/*query-editor*/}
                    <div>
                        {/*<Label className={'text-theme-resp fw-bold fs-normal'}>*/}
                        {/*    Query Editor*/}
                        {/*</Label>*/}
                        {animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(10).render(
                            <ThemedInput
                                wrapperClassName={'mt-1x'}
                                className={''}
                                placeholder={'Type your query here'}
                                id={'queryValue'}
                                value={getField(Fields.queryValue)}
                                showMsg={false}
                                asTextArea={true}
                                style={{
                                    height: '80px',
                                    minHeight: '50px',
                                    maxHeight: '400px'
                                }}
                                contentEditable={true}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    updateField(Fields.queryValue, value);
                                    panelLog('');
                                }}
                                onKeyDown={(e) => {
                                    if (e.ctrlKey && e.key == 'Enter') {
                                        e.preventDefault();
                                        // toast(`Ctrl+Enter detected!`);
                                        handleExecQuery();
                                    }
                                }}
                            />
                        )}

                        {/*submit-btn*/}
                        {animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(100).render(
                            <Flexbox className={'mt-1'} justifyAt={'between'}>
                                <Flexbox className={''}>
                                    {/*submit-btn*/}
                                    <ThemedButton
                                        className={'w-auto px-2 fs-sm py-1'}
                                        text={'Execute Query'}
                                        // text={isFieldTrue(Fields.submitAsLoading) ? 'Executing Query...' : 'Execute Query'}
                                        // elasticActive={true}
                                        height={'28px'}
                                        icon={isFieldTrue(Fields.submitAsLoading) ? '' : `bi bi-play fs-normal me-n1 pe-1`}
                                        loadingSizeVariant={'sm'}
                                        asLoading={isFieldTrue(Fields.submitAsLoading)}
                                        disabled={isFieldTrue(Fields.submitDisable)}
                                        onClick={handleExecQuery}
                                    />

                                    {/*tbl-list btn*/}
                                    {/*<ThemedButton*/}
                                    {/*    className={'w-auto px-2 fs-sm py-1'}*/}
                                    {/*    text={'Show Database Tables'}*/}
                                    {/*    outlined={true}*/}
                                    {/*    height={'28px'}*/}
                                    {/*    mx={2}*/}
                                    {/*    ml={3}*/}
                                    {/*    hoverBgColor={theme.primary20}*/}
                                    {/*    hoverColor={theme.primary}*/}
                                    {/*    rippleColor={theme.primary40}*/}
                                    {/*    hoverBorderColor={theme.t}*/}
                                    {/*    asLoading={isFieldTrue(Fields.fetchTblListBtbAsLoading)}*/}
                                    {/*    disabled={isFieldTrue(Fields.fetchTblListBtDisable)}*/}
                                    {/*    onClick={() => handleFetchDbTables()}*/}
                                    {/*/>*/}
                                </Flexbox>

                                <Label className={`text-theme-resp-50 fw-semi-bold fs-md-xs select-none rounded-2 m-0 px-1 py-1 d-flex jc-center al-center`}
                                       style={{backgroundColor: theme.text10, height: '18px'}}
                                       tooltip={`Press 'Ctrl+Enter' to execute SQL query`}>
                                    {'Ctrl+Enter'}
                                </Label>
                            </Flexbox>
                        )}
                    </div>

                    {/*query-preview*/}
                    {animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(200).render(
                        <div>
                            <Flexbox className={''} alignAt={'start'}>
                                <Label className={'text-theme-resp-50 fw-bold fs-md select-none'}>
                                    Query Preview
                                </Label>

                                {checkNullStr(getField(Fields.queryValue)) && <ThemedIconButton
                                    className={'fs-sm p-2'}
                                    tooltip={'Copy Query'}
                                    outlined={true}
                                    mx={1}
                                    elasticActive={true}
                                    circular={false}
                                    borderWidth={0}
                                    size={'22px'}
                                    icon={IconClass.copy}
                                    // bgColor={theme.primary05}
                                    onClick={() => {
                                        copyTextToClipboard(getField(Fields.queryValue));
                                        toast('Query copied to clipboard', CssVariant.info);
                                    }}
                                />}
                            </Flexbox>
                            <div className={'mt-1'}>
                                <PrismSyntaxHighlighter
                                    language="sql"
                                    code={getField(Fields.queryValue)}
                                    style={{
                                        height: '80px',
                                        minHeight: '50px',
                                        maxHeight: '400px'
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </GridBox>

                {/*msg-box*/}
                {(checkNullStr(getField(Fields.panelMsg))) &&
                    <MsgBox color={getField(Fields.panelMsgColor, theme.text90)}>
                        {getField(Fields.panelMsg)}
                    </MsgBox>}

                {/*view-toggle*/}
                <div className={'mt-3'}>
                    {animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(300).render(
                        <Flexbox className={''} justifyAt={''}>
                            <PolyStateToggle
                                className={''}
                                variant={'success'}
                                bgVariant={'transparent'}
                                rippleVariant={'light'}
                                reverseVariant={'white'}
                                itemClassName={''}
                                itemIconClassName={''}
                                fsVariant={'md-xs'}
                                defOption={getField(Fields.currVisPanelId)}
                                onSwitch={(text, index, item) => {
                                    log('onSwitch.item:', item, 'text:', text, 'item:', item);
                                    updateField(Fields.currVisPanelId, index);

                                    if (index == PanelTypes.tableView.id) {
                                        handleFetchDbTables();
                                    }
                                }}>
                                {Object.values(PanelTypes)}
                            </PolyStateToggle>
                        </Flexbox>
                    )}
                </div>

                {/*panels*/}
                {animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(400).render(
                    <div className={'mt-2'}>
                        {getField(Fields.currVisPanelId) == PanelTypes.tableView.id && renderTableListPanel()}
                        {getField(Fields.currVisPanelId) == PanelTypes.queryResultsView.id && renderResultTablePanel()}
                    </div>
                )}
            </div>
        </AdminInterface>
    </>)

    function renderResultTablePanel() {
        return <div className={''}>
            <Label className={'text-theme-resp-60 fw-bold fs-normal my-1'}>Query Results</Label>
            {/*<div>queryResults: {jsonToStr(getField(Fields.queryResults))}</div>*/}
            {/*<div>tableColumnModel: {jsonToStr(getField(Fields.tableColumnModel))}</div>*/}

            {(isFieldTrue(Fields.submitAsLoading)
                || (!isFieldTrue(Fields.submitAsLoading) && checkNullArr(getField(Fields.queryResults, []))))
                ? <div className={``}>
                    {isFieldTrue(Fields.submitAsLoading)
                        ? <TableSkeleton/>
                        : <ModuleTable
                            moduleName={moduleName}
                            columnModel={getField(Fields.tableColumnModel, {})}
                        >
                            {getField(Fields.queryResults, [])}
                        </ModuleTable>
                    }
                </div>
                : <NullMsgLabel className={'text-theme-resp'}>
                    {getField(Fields.queryExecMsg)}
                </NullMsgLabel>}
        </div>
    }

    function renderTableListPanel() {
        return <div className={''}>
            <Flexbox className={'my-1'} alignAt={'center'}>
                <Label className={'text-theme-resp-60 fw-bold fs-normal'}>Database Tables</Label>

                <ThemedIconButton
                    className={'fs-md p-2 border-none'}
                    tooltip={'Refresh Tables'}
                    outlined={true}
                    mx={2}
                    elasticActive={true}
                    size={'26px'}
                    icon={IconClass.refresh}
                    // bgColor={theme.primary05}
                    disabled={isFieldTrue(Fields.fetchTblListBtDisable)}
                    asLoading={isFieldTrue(Fields.fetchTblListBtbAsLoading)}
                    loadingColorVariant={CssVariant.primary}
                    onClick={() => handleFetchDbTables(false)}
                />
            </Flexbox>

            <Flexbox className={'my-1 mx-5 w-auto'}>
                {isFieldTrue(Fields.fetchTblListBtbAsLoading) && <CircleLoading justifyAt={''}/>}
            </Flexbox>
            {/*<div>dbTables: {jsonToStr(getField(Fields.dbTables))}</div>*/}

            {!isFieldTrue(Fields.fetchTblListBtbAsLoading)
                && <div className={'d-flex w-autox jc-start w-m-50x'}>
                    <Section className={'p-0 scroller scroller-y-auto app-section'} roundedVariant={3}
                             borderColor={theme.text30} height={'210px'}>
                        {checkNullArr(getField(Fields.dbTables))
                            ? <div className={'grid-layoutmd'}>{
                                getField(Fields.dbTables).map((item, index) => {
                                    return <div key={index}>
                                        <div
                                            className={`px-2 xpy-1 text-theme-resp cursor-pointer transition highlight-dark-hover highlight-dark-active ${index > 0 ? `border-top-1 border-theme-resp-30` : ''}`}
                                            onClick={() => {
                                                const fun = 'copyTableToClipboard:';
                                                try {
                                                    copyTextToClipboard(Object.values(item)[0]);
                                                    toast('Table copied to clipboard!', CssVariant.info);
                                                } catch (error) {
                                                    toast('Copy failed!', CssVariant.danger);
                                                    logErr(fun, error);
                                                }
                                            }}>
                                            {jsonToStr(Object.values(item)[0])}
                                        </div>
                                    </div>
                                })}</div>
                            : <NullMsgLabel>No tables found!</NullMsgLabel>}
                    </Section>
                </div>}
        </div>
    }

    async function handleExecQuery() {
        const fun = 'handleExecQuery:';
        const query = getField(Fields.queryValue);

        //Query null-check
        if (!checkNullStr(query)) {
            toast("Query cannot be empty!", CssVariant.warning);
            focusFormIdElement('queryValue', true);
            return false;
        }
        //Check Offline
        if (!isOnline) {
            toast("You're offline!", CssVariant.warning);
            return false;
        }

        //restrict keywords
        const queryL = (query + '').toLowerCase();
        for (const resKw of RESTRICTED_SQL_KEYWORDS) {
            if (queryL.includes((resKw + '').trim().toLowerCase())) {
                const msg = `Restricted keyword found: '${resKw}'. Such keywords are now allowed because they can damage the database!`;
                toast(msg, CssVariant.warning);
                panelLogErr(`DANGER: ${msg}`);

                updateField(Fields.queryExecSuccess, false);
                updateField(Fields.queryExecMsg, '');
                updateField(Fields.queryResults, []);
                updateField(Fields.tableColumnModel, {});

                return false;
            }
        }

        const proceed = true;
        // const proceed = false;
        if (proceed) {
            try {
                updateField(Fields.submitAsLoading, true);
                updateField(Fields.submitDisable, true);
                updateField(Fields.queryExecSuccess, false);
                updateField(Fields.queryExecMsg, '');
                updateField(Fields.queryResults, []);
                updateField(Fields.tableColumnModel, {});
                panelLog('');

                const REQUEST_OPTIONS = {query};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__queryWindow_fetchRunQueryResults,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');
                        const error = getJsonValue(fetchedData, 'error');
                        if (success) {
                            toast(message, CssVariant.success);
                            updateField(Fields.queryExecSuccess, true);
                            updateField(Fields.queryExecMsg, message);

                            const results = getJsonValue(fetchedData, 'data', []);
                            if (checkNullArr(results)) {
                                const {records, columnModel} = transformQueryResultsIntoTableRows(results);
                                // log(fun, 'results.converted.records:', records, 'columnModel:', columnModel);
                                updateField(Fields.tableColumnModel, columnModel);
                                updateField(Fields.queryResults, records);
                                updateField(Fields.currVisPanelId, PanelTypes.queryResultsView.id);
                            }
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.panelMsg, error);
                            // panelLogErr(`Error: ${jsonToStr(error)}`);
                            panelLogErr(`Error: ${jsonToStr(getJsonValue(error, 'sqlMessage'))}`);
                        }
                        updateField(Fields.submitAsLoading, false);
                        updateField(Fields.submitDisable, false);
                    }),
                    onError: ((error) => {
                        toast('Query execution failed, please try again!', CssVariant.danger);
                        panelLogErr('Query execution failed, please try again!');
                        updateField(Fields.submitAsLoading, false);
                        updateField(Fields.submitDisable, false);
                        logErr(fun, error);
                    }),
                });
            } catch (error) {
                toast('Query execution failed, please try again!', CssVariant.danger);
                panelLogErr('Query execution failed, please try again!');
                updateField(Fields.submitAsLoading, false);
                updateField(Fields.submitDisable, false);
                logErr(fun, error);
            }
        } else {
            toast("Action temporarily disabled", CssVariant.warning);
        }
    }

    async function handleFetchDbTables(checkBefore = true) {
        const fun = 'handleFetchDbTables:';
        updateField(Fields.currVisPanelId, PanelTypes.tableView.id);
        if (!isOnline) {
            toast("You're offline!", CssVariant.warning);
            return false;
        }
        if (!checkBefore || (checkBefore && !checkNullArr(getField(Fields.dbTables)))) {
            try {
                updateField(Fields.fetchTblListBtbAsLoading, true);
                updateField(Fields.fetchTblListBtDisable, true);
                updateField(Fields.dbTables, []);
                panelLog('');

                const REQUEST_OPTIONS = {};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__queryWindow_fetchDbTables,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');
                        const error = getJsonValue(fetchedData, 'error');
                        if (success) {
                            toast(message, CssVariant.success);
                            const tables = getJsonValue(fetchedData, 'data', []);
                            updateField(Fields.dbTables, tables);
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.panelMsg, error);
                            panelLogErr(`Error: ${jsonToStr(getJsonValue(error, 'sqlMessage'))}`);
                        }
                        updateField(Fields.fetchTblListBtbAsLoading, false);
                        updateField(Fields.fetchTblListBtDisable, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.fetchError, CssVariant.danger);
                        panelLogErr(Messages.fetchError);
                        updateField(Fields.fetchTblListBtbAsLoading, false);
                        updateField(Fields.fetchTblListBtDisable, false);
                        logErr(fun, error);
                    }),
                });
            } catch (error) {
                toast(Messages.fetchError, CssVariant.danger);
                panelLogErr(Messages.fetchError);
                updateField(Fields.fetchTblListBtbAsLoading, false);
                updateField(Fields.fetchTblListBtDisable, false);
                logErr(fun, error);
            }
        }
    }

    function transformQueryResultsIntoTableRows(queryResults) {
        const fun = 'transformQueryResultsIntoTableRows:';
        let records = [];
        let columnModel = {};

        // log(fun, 'queryResults:', queryResults);
        try {
            if (checkNullArr(queryResults)) {
                const columns = Object.keys(queryResults[0]);
                columnModel = convertFieldsToColumnModel(columns);
                // log(fun, 'queryResults.columns:', columns, 'columnModel:', columnModel);

                // records = queryResults;
                queryResults.map((record, index) => {
                    if (checkNullJson(record)) {
                        records.push({
                            id: index,
                            recordId: index,
                            ...formatTableRow(record, [], columnModel)
                        })
                    }
                })
            }
        } catch (error) {
            logErr(fun, error);
        }
        return {records, columnModel};
    }

    /**
     * Format admin-module-json record using {@link AdminModuleFieldsData} or with specified columns object.
     *
     * @param {object} tableRow Json-data to be formatted.
     * @param {array} skipCols Columns to skip when formatting data.
     * @param {object} columns OPTIONAL Object of columns for the module.
     * @param {object} useTitle Whether to use 'title' or 'column'. Default is true.
     *
     * @example
     * const tableRow = { id: 1, username: 'pparker', name: 'Peter Parker', password: '34rxdy654', age: 34,  };
     * const columns = ModuleColumns[Modules.UserProfile];
     * const skipCols = [ columns.id, columns.password ];
     * const formattedData = admin__formatModuleJsonRecord(Modules.UserProfile, fetchedRecord, skipCols);
     * console.log('formattedData:', formattedData);
     * //result: { "Username": 'pparker', "Full Name": 'Peter Parker', "Age": 34,  } //with: useTitle=true
     * //result: { "username": 'pparker', "name": 'Peter Parker', "age": 34,  } //with: useTitle=false
     */
    function formatTableRow(tableRow = {}, skipCols = [], columns = {}, useTitle = true) {
        const fun = 'formatTableRow:';
        // log(fun,'tableRow:', tableRow, 'columns:', columns, 'skipCols:', skipCols, 'useTitle:', useTitle);
        if (!checkNullJson(tableRow) || !checkNullJson(columns)) return {};
        try {
            const accessKey = isBoolTrue(useTitle) ? 'title' : 'column';
            if (checkNullArr(skipCols)) {
                skipCols = skipCols.map(item => item[accessKey]);
            }

            return Object.entries(columns).reduce((acc, [colKey, colObj]) => {
                if (checkNullArr(skipCols)) {
                    if (!skipCols.includes(colObj[accessKey])) {
                        acc[colObj[accessKey]] = tableRow[colObj.column];
                    }
                } else {
                    acc[colObj[accessKey]] = tableRow[colObj.column];
                }
                return acc;
            }, {});
        } catch (error) {
            logErr(fun, error);
            return {};
        }
    }

    /**
     *
     * @example
     * const fields = `roles_id, roles_name, permission, status, insert_date, insert_by, update_date, update_by`.split(', ');
     * const result = convertFieldsToColumnModel(fields);
     * console.log(result);
     *
     * //output:
     * {
     *   rolesId: { column: 'roles_id', title: 'Roles Id' },
     *   rolesName: { column: 'roles_name', title: 'Roles Name' },
     *   permission: { column: 'permission', title: 'Permission' },
     *   status: { column: 'status', title: 'Status' },
     *   insertDate: { column: 'insert_date', title: 'Insert Date' },
     *   insertBy: { column: 'insert_by', title: 'Insert By' },
     *   updateDate: { column: 'update_date', title: 'Update Date' },
     *   updateBy: { column: 'update_by', title: 'Update By' }
     * }
     */
    function convertFieldsToColumnModel(fields = []) {
        const fun = 'convertFieldsToColumnModel:';
        const json = {
            recordId: {column: fields[0], title: "recordId"}
        };
        try {
            fields.forEach(field => {
                const camelCaseName = field.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
                const spacedName = camelCaseName.split(/(?=[A-Z])/).join(' ');
                const capitalizedWords = spacedName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1));
                const title = capitalizedWords.join(' ');
                json[camelCaseName] = {
                    column: field,
                    title: title,
                    cellType: AdminModuleTableCellType.STRING,
                    show: true,
                    defShow: true,
                    sortable: true,
                    hideable: true,
                    searchable: true,
                    exportable: true,
                    width: (title + '').length * 10,
                    // width: 220,
                };
            });
        } catch (error) {
            logErr(fun, error);
        }
        return json;
    }


    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function toast(text, variant) {
        showToast(text + '');
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default QueryWindowPage;
